import script from "./LottieButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LottieButton.vue?vue&type=script&setup=true&lang=js"

import "./LottieButton.vue?vue&type=style&index=0&id=682ecc72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-682ecc72"]])

export default __exports__